const viewers = document.querySelectorAll(".image-compare");

const options = {
  // UI Theme Defaults
  controlColor: "#FFFFFF",
  controlShadow: true,
  addCircle: false,
  addCircleBlur: true,

  // Label Defaults
  showLabels: false,
  labelOptions: {
    before: "Before",
    after: "After",
    onHover: false
  },

  // Smoothing
  smoothing: false,

  // Other options
  hoverStart: false,
  verticalMode: false,
  startingPoint: 50,
  fluidMode: false
};

// Prevent `touchstart`, `touchmove`, and `touchend` default behavior for iOS
viewers.forEach((element) => {
  ["touchstart", "touchmove", "touchend"].forEach((eventName) => {
    element.addEventListener(eventName, (e) => {
      e.preventDefault(); // Prevent page refresh, scrolling, or unintended behavior
    }, { passive: false });
  });

  // Initialize the viewer
  let view = new ImageCompare(element, options).mount();
});